import { render, staticRenderFns } from "./PieChartDashboard.vue?vue&type=template&id=944c4e96&scoped=true"
import script from "./PieChartDashboard.vue?vue&type=script&lang=js"
export * from "./PieChartDashboard.vue?vue&type=script&lang=js"
import style0 from "./PieChartDashboard.vue?vue&type=style&index=0&id=944c4e96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944c4e96",
  null
  
)

export default component.exports